import axiosInstance from "./api";
import TokenService from "./token.service";

const setup = (store) => {
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = TokenService.getLocalAccessToken();
            if (token) {
                config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;

            if (originalConfig.url !== "/auth/jwt/login" && originalConfig.url !== "/auth/jwt/refresh" && err.response) {
                // Access Token was expired

                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;

                    try {
                        const res = await axiosInstance.post("/auth/jwt/refresh")
                        store.commit('SET_TOKEN_TO_VUEX', res.data.accessToken);
                        originalConfig.headers["Authorization"] = 'Bearer ' + res.data.accessToken;
                        return axiosInstance(originalConfig);

                        // console.log('Запрос на refresh');
                        // console.log(rs.status, rs.data);
                        // return Promise.reject()
                        // if (!rs) {
                        //     console.log('401')
                        //     this.$store.commit('logout')
                        //     localStorage.removeItem('access_token')
                        //     localStorage.removeItem('user_data')
                        //     delete this.axios.defaults.headers.common['Authorization']
                        //     await this.$router.push('/login')
                        //     return axiosInstance(originalConfig);
                        // } else {
                        //     const {accessToken} = rs.data.access_token;
                        //     store.commit('SET_TOKEN_TO_VUEX', accessToken);
                        //     // TokenService.updateLocalAccessToken(accessToken);
                        //     return axiosInstance(originalConfig);
                        // }

                    } catch (_error) {
                        console.log('Ошибка при обновлении токена', _error);
                        store.commit('logout')
                        localStorage.removeItem('access_token')
                        localStorage.removeItem('user_data')
                        delete axiosInstance.defaults.headers.common['Authorization']
                        document.location.href = '/login';
                        return Promise.reject(_error)

                    }
                }
            }

            return Promise.reject(err);
        }
    );
};

export default setup;
